module.exports = __webpack_public_path__ + "public/img/goodsimg.e6aeffbf.png";